import { REMOVE_SHARED_CONNECTORS } from "redux/constants/portal";
import { UPDATE_SHARED_CONNECTOR } from "redux/constants/portal";
import { SET_SHARED_CONNECTORS } from "redux/constants/portal";
import {
  SET_OWNED_CONNECTORS,
  SET_PURCHASED_CONNECTORS,
  ADD_SHARED_CONNECTORS,
} from "redux/constants/portal";

const initialState = {
  ownedConnectors: [],
  purchasedConnectors: [],
  sharedConnectors: [],
};

const view = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_OWNED_CONNECTORS:
      return {
        ...state,
        ownedConnectors: payload,
      };
    case SET_PURCHASED_CONNECTORS:
      return {
        ...state,
        purchasedConnectors: payload,
      };
    case SET_SHARED_CONNECTORS:
      return {
        ...state,
        sharedConnectors: payload,
      };
    case ADD_SHARED_CONNECTORS:
      return {
        ...state,
        sharedConnectors: state.sharedConnectors.concat(payload),
      };
    case REMOVE_SHARED_CONNECTORS:
      return {
        ...state,
        sharedConnectors: state.sharedConnectors.filter(
          (sharedConnector) => !payload.includes(sharedConnector.id)
        ),
      };
    case UPDATE_SHARED_CONNECTOR:
      return {
        ...state,
        sharedConnectors: state.sharedConnectors.map((sharedConnector) =>
          sharedConnector.id === payload.id
            ? {
                ...sharedConnector,
                ...payload,
              }
            : sharedConnector
        ),
      };
  }
  return state;
};

export default view;
